export default function MemberTradeRulesDetailCtrl($scope, $sce, $wamp, $stateParams) {
  $wamp.call('org.eggs.traderule', [$stateParams.page])
      .then(function (page) {
        $scope.page = $sce.trustAsHtml(page);
      });
}
